import { AboutThree } from "../../components/About/AboutThree";
import { BlogAreaTwo } from "../../components/BlogAreas/BlogAreaTwo";
import { RequestAreaTwo } from "../../components/RequestAreas/RequestAreaTwo";
import { ServicesTwo } from "../../components/Services/ServicesTwo";
import { Layout } from "../../layouts/Layout";
import { H2_BANNER_IMG, H2_BANNER_SHAPE01, H2_BANNER_SHAPE02, H2_BANNER_SHAPE03,
} from "../../lib/assets";
import { Link } from "react-router-dom";
import { VideoPlayerOne } from '../../components/VideoPlayers/VideoPlayerOne'
import  CoreStrengths from '../../components/home/CoreStrengths'
import WhyChooseUs from "../../components/home/WhyChooseUs";



const Home = () => {
  return (
    <Layout header={4} footer={2}>
     
       <section className="banner-area-two banner-bg-two">
             <div className="container">
               <div className="row align-items-center">
                 <div className="col-lg-6">
                   <div className="banner-content-two">
                     <span
                       className="sub-title"
                       data-aos="fade-up"
                       data-aos-delay="0"
                     >
                       Your Partner in 
                     </span>
                     <h2 className="title" data-aos="fade-up" data-aos-delay="300">
                       Legal Excellence & Corporate Success
                     </h2>
                     <p data-aos="fade-up" data-aos-delay="500">
                       M/s BLAK & CO. (Company Secretaries) and M/s GOBIZ LEGAL (Law Firm) form a distinguished professional alliance dedicated to delivering comprehensive, strategic, and solution-oriented legal, secretarial, and regulatory services. With a client-centric philosophy and a commitment to precision, integrity, and responsiveness, we assist businesses, institutions, and entrepreneurs in navigating the complexities of corporate law, compliance, governance, litigation, and allied advisory matters with confidence and clarity.
                     </p>
                     <div className="banner-btn">
                       <Link
                         to="/services"
                         className="btn"
                         data-aos="fade-right"
                         data-aos-delay="700"
                       >
                         Our Services
                       </Link>
     
                       <VideoPlayerOne
                         src="#"
                         text="Watch The Video"
                         data-aos="fade-left"
                         data-aos-delay="700"
                       />
                     </div>
                   </div>
                 </div>
                 <div className="col-lg-6">
                   <div className="banner-img text-center">
                     <img
                       src={H2_BANNER_IMG}
                       alt=""
                       data-aos="fade-left"
                       data-aos-delay="400"
                     />
                   </div>
                 </div>
               </div>
             </div>
             <div className="banner-shape-wrap">
               <img src={H2_BANNER_SHAPE01} alt="" />
               <img src={H2_BANNER_SHAPE02} alt="" />
               <img
                 src={H2_BANNER_SHAPE03}
                 alt=""
                 data-aos="zoom-in-up"
                 data-aos-delay="800"
               />
             </div>
           </section>


      {/* about-area */}
      <AboutThree />

<CoreStrengths />

      {/* services-area */}
      <ServicesTwo />

      <WhyChooseUs />
      
      {/* blog-area */}
      <BlogAreaTwo />

      {/* request-area  */}
      <RequestAreaTwo />
    </Layout>
  );
};

export default Home;
